import { cx } from "@jugl-web/utils";

export type LoadingSpinnerSize = "xs" | "sm" | "md";

export type LoadingSpinnerColor =
  | "primary"
  | "white"
  | "grey"
  | "dark"
  | "violet";

export interface LoadingSpinnerProps {
  size?: LoadingSpinnerSize | number;
  color?: LoadingSpinnerColor;
  className?: string;
}

const sizeToClasses: Record<LoadingSpinnerSize, string> = {
  xs: "h-4 w-4",
  sm: "h-5 w-5",
  md: "h-10 w-10",
};

const colorToClasses: Record<LoadingSpinnerColor, string> = {
  primary: "fill-primary",
  white: "fill-white",
  grey: "fill-[#828282]",
  dark: "fill-dark",
  violet: "fill-[#7C3AED]",
};

const backgroundColorToClasses: Record<LoadingSpinnerColor, string> = {
  primary: "fill-grey-200",
  white: "fill-tertiary-200",
  grey: "fill-grey-400",
  dark: "fill-[#E0E0E0]",
  violet: "fill-[#D4B7EB]",
};

export const LoadingSpinner = ({
  size = "md",
  color = "primary",
  className,
}: LoadingSpinnerProps) => (
  <div
    aria-label="Loading..."
    role="status"
    className={cx("flex items-center justify-center", className)}
  >
    <svg
      className={cx(
        "animate-spin",
        typeof size === "string" ? sizeToClasses[size] : undefined
      )}
      style={{
        width: typeof size === "number" ? `${size}px` : undefined,
        height: typeof size === "number" ? `${size}px` : undefined,
      }}
      viewBox="3 3 18 18"
    >
      <path
        className={cx("fill-grey-200", backgroundColorToClasses[color])}
        d="M12 5C8.13401 5 5 8.13401 5 12C5 15.866 8.13401 19 12 19C15.866 19 19 15.866 19 12C19 8.13401 15.866 5 12 5ZM3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12Z"
      />
      <path
        className={cx("fill-primary", colorToClasses[color])}
        d="M16.9497 7.05015C14.2161 4.31648 9.78392 4.31648 7.05025 7.05015C6.65973 7.44067 6.02656 7.44067 5.63604 7.05015C5.24551 6.65962 5.24551 6.02646 5.63604 5.63593C9.15076 2.12121 14.8492 2.12121 18.364 5.63593C18.7545 6.02646 18.7545 6.65962 18.364 7.05015C17.9734 7.44067 17.3403 7.44067 16.9497 7.05015Z"
      />
    </svg>
  </div>
);
